import { Volume2 } from "lucide-react";
import { playNarration } from "../../lib/narration";

const PARTS = [
  ["briefing", "Briefing (intro screen, spoken on Begin)", 6],
  ["note_25", "Lab note at 25%", 3],
  ["note_50", "Lab note at 50%", 3],
  ["note_75", "Lab note at 75%", 3],
  ["finale", "Conclusion (spoken on the final screen) - use {subject}, {father}, {nickname}", 5],
];

export const NarrationEditor = ({ narration = {}, onChange }) => (
  <div data-testid="narration-editor" className="grid gap-4">
    {PARTS.map(([key, label, rows]) => (
      <div key={key}>
        <div className="flex items-center justify-between gap-3">
          <label className="lab-label">{label}</label>
          <button type="button" data-testid={`narration-play-${key}`} onClick={() => playNarration(key)} className="lab-icon-btn h-7 w-7" title="Hear saved version">
            <Volume2 size={13} />
          </button>
        </div>
        <textarea
          data-testid={`narration-${key}`}
          rows={rows}
          value={narration[key] || ""}
          onChange={(e) => onChange({ ...narration, [key]: e.target.value })}
          className="lab-input mt-2 w-full text-sm leading-relaxed"
        />
      </div>
    ))}
    <p className="text-xs text-slate-500">Spoken with ElevenLabs v3 - direct the performance with tags in square brackets, e.g. [gasps], [whispers], [nervous laugh], [long pause], [voice breaking]. Tags are heard, never shown on the kiosk. Audio is generated the first time each text is heard, then cached; edit, save, and the next play uses the new version.</p>
  </div>
);
